angular.module('unergie.main')
.directive('changeEmail', (AlertManager, ApiUser, BoFeaturesService, AdminComments, ErrorCatcher) => ({
    restrict: 'E',
    scope: {
        account: '=',
        process: '=?',
        buttonlabel: '=?',
        onEmailChange: '&?',
    },
    templateUrl: '/directives/changeEmail/changeEmail.html',
    link($scope) {
        const feats = BoFeaturesService.getModuleFeatures('accountinfo')
        const enableProcess = $scope.process === false ? false : feats.emailProcess
        $scope.isAIFeatureOn = (feature) => feats[feature]

        const chgMailTemplate = { newMail: '', process: enableProcess }
        const newMailField = {
            newMail: {
                required: true,
                forceLowercase: true,
                label: 'E-mail',
                type: 'email',
            },
        }
        const processField = !enableProcess ? {} : {
            process: {
                required: true,
                label: 'Modif sans envoi',
                type: 'select',
                enum: [
                    { label: 'Avec envoi', value: true },
                    { label: 'Sans envoi (direct BDD)', value: false },
                ],
            },
        }
        $scope.chgMailPayload = angular.copy(chgMailTemplate)
        $scope.chgMailFields = _.assign({}, newMailField, processField)

        $scope.initChangeMail = () => {
            $scope.chgMailPayload = _.assign({}, chgMailTemplate, { newMail: $scope.account.mail })
        }

        $scope.changeMail = function () {
            if ($scope.chgMailPayload.newMail === $scope.account.mail) {
                AlertManager.error('Même E-mail !')
            }
            if ($scope.chgMailPayload.process) {
                ApiUser.changeEmail({ idAccount: $scope.account.id, send: true }, { new_email: $scope.chgMailPayload.newMail }).$promise.then(() => {
                    AlertManager.success(`Email envoyé à ${$scope.chgMailPayload.newMail}`)
                    const comment = `<b>AUTOMATIQUE</b> : Attente validation via le mail envoyé au client pour changement adresse mail. ` +
                    `Ancien : <b>${$scope.account.mail}</b>, nouveau : <b>${$scope.chgMailPayload.newMail}</b>`
                    AdminComments.addComment({ object: $scope.account.customer_id, comment }).$promise.catch(ErrorCatcher)
                    $scope.onEmailChange(_.assign({}, $scope.chgMailPayload))
                }).catch(ErrorCatcher)
            } else {
                ApiUser.updateAccount({ id_account: $scope.account.id }, { mail: $scope.chgMailPayload.newMail }).$promise.then(() => {
                    AlertManager.success('Compte modifié')
                    $scope.onEmailChange(_.assign({}, $scope.chgMailPayload))
                }).catch(ErrorCatcher)
            }
        }
    },
}))
